import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_get_inventoryService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { aggregation_level?: string, filters?: $types.FootPrintApiManager.input_get_inventory, paging?: { top?: number, skip?: number } }): Promise<{ aggregation_level?: string, inventory?: $types.FootPrintApiManager.public_inventory[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/get_inventory`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

